module.exports = __webpack_public_path__ + "img/batb.d0289dc0.png";